import { configureStore } from '@reduxjs/toolkit'

import { useDispatch } from 'react-redux'
import RemoconModal from '@store/Slices/RemoconModal'
import LanguageSlice from './Slices/LanguageState'

const store = configureStore({
  reducer: {
    modal: RemoconModal.reducer,
    language: LanguageSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export default store
